import { useDispatch } from "react-redux";
import { authorFilter, categoryFilter } from "./../Redux/filters/actionCreator";

const Blog = ({ blogDetails }) => {
  const { title, authorAvatar, category, author, thumbnail, date, readTime } = blogDetails;
  const dateString = new Date(date);
  const dispatch = useDispatch();
  return (
    <div className='flex flex-col rounded-lg shadow-lg overflow-hidden'>
      <div className='flex-shrink-0'>
        <img className='h-48 w-full object-cover' src={thumbnail} alt='thumbnail' />
      </div>

      <div className='flex-1 bg-white p-6 flex flex-col justify-between'>
        <div className='flex-1'>
          <p className='text-sm font-medium text-indigo-600'>
            <span
              onClick={() => dispatch(categoryFilter(category))}
              className='cursor-pointer inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800'
            >
              {category}
            </span>
          </p>
          <a href='google.com' className='block mt-1'>
            <p className='text-xl font-semibold text-gray-900'>{title}</p>
          </a>
        </div>
        <div className='mt-6 flex items-center'>
          <div className='flex-shrink-0 cursor-pointer'>
            <img className='h-10 w-10 rounded-full' src={authorAvatar} alt='' />
          </div>
          <div className='ml-3'>
            <p
              onClick={() => dispatch(authorFilter(author))}
              className='text-sm font-medium text-gray-900 hover:underline cursor-pointer'
            >
              {author}
            </p>
            <div className='flex space-x-1 text-sm text-gray-500'>
              <time dateTime={date}>{dateString.toDateString()} </time>
              <span aria-hidden='true'> &middot; </span>
              <span> {readTime} min read </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
